import { useState } from "react";
import { ImageIcon } from "lucide-react";
import { resolveAssetUrl } from "@/lib/assetUrl";

/**
 * ProductImage — branded fallback + object-cover.
 * Prevents the browser's broken-image glyph from ever showing on a
 * product card by swapping to a TBC-styled placeholder on error.
 * Keeps consistent aspect ratio so grids stay tidy.
 */
export function ProductImage({ src, alt, className = "", aspect = "aspect-square", testId }) {
  const [broken, setBroken] = useState(false);
  const resolved = resolveAssetUrl(src);
  const showPlaceholder = broken || !resolved;

  return (
    <div className={`relative ${aspect} overflow-hidden bg-tbc-cream ${className}`} data-testid={testId}>
      {showPlaceholder ? (
        <div className="absolute inset-0 flex flex-col items-center justify-center gap-1.5 text-tbc-gold/70 bg-gradient-to-br from-tbc-cream to-tbc-cream/60">
          <ImageIcon className="w-8 h-8" strokeWidth={1.4} />
          <span className="text-[10px] uppercase tracking-widest font-medium">TBC</span>
        </div>
      ) : (
        <img
          src={resolved}
          alt={alt || ""}
          loading="lazy"
          onError={() => setBroken(true)}
          className="absolute inset-0 w-full h-full object-cover"
        />
      )}
    </div>
  );
}

export default ProductImage;
